<template>
    <div
        v-if="Object.keys(payout).length"
        :style="payoutContainerStyle"
        class="payout-summary-artist-container"
    >
        <p class="title">Payout Summary</p>
        <div :style="payoutWrapperStyle" class="payout-wrapper">
            <p class="payout-info">You Get: {{ payoutInfo }}</p>
            <p class="payout-paid-by">{{ payoutPaidBy }}</p>
        </div>
        <div class="payout-languages">
            <p class="payout-paid-by">{{ payoutLanguage }}</p>
        </div>
        <div class="hedlyner-msg">
            <p class="payout-info">
                You’re all set! Payouts made through Hedlyner are automatically charged 24
                hours prior to the start of the event, and automatically clear 48 hours after
                the start of the event.
            </p>
            <p class="payout-support">
                Last minute cancellations or other problems?
                <a :href="URLS.redirect.support" target="_blank" class="contact-support">
                    Contact artist support for help.
                </a>
            </p>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import { notification } from '@/helpers/notification'
    import useCheckScreen from '@/composables/useCheckScreen.js'

    const URLS = {
        xhr: {
            fetch: {
                artistPayout: ['/booking-manager/artist', 'payout']
            }
        },
        redirect: {
            support: '/contact-us'
        }
    }
    export default {
        name: 'PayoutSummary',
        props: {
            eventId: {
                type: Number
            }
        },
        data: () => ({
            payout: {}
        }),
        computed: {
            URLS: () => URLS,
            payoutInfo: (self) =>
                ` $${parseFloat(self.payout.payout_info.artist_get).toFixed(2)}`,
            payoutPaidBy: (self) =>
                self.payout.payment_method === 'Cash' ? 'Paid via Cash' : `Paid via Hedlyner`,
            payoutClearsDate: (self) => {
                if (self.payout.clears === 'n/a') return 'clears n/a'

                return `Clears ${self.payout.clears}`
            },
            hedlynerCommission: (self) =>
                (self.payout.payout_info.venue_pays * self.payout.artist_fee).toFixed(2),
            payoutLanguage: (self) =>
                `Artist Fee: $${parseFloat(self.payout.payout_info.venue_pays).toFixed(
                    2
                )}, Hedlyner Commission: $${self.hedlynerCommission}. ${
                    self.payoutClearsDate
                }`,
            payoutContainerStyle: (self) =>
                self.screen.isMobile.value
                    ? {
                          background: 'transparent',
                          padding: '0px 16px',
                          gap: '16px'
                      }
                    : {},
            payoutWrapperStyle: (self) =>
                self.screen.isMobile.value
                    ? {
                          'flex-direction': 'column',
                          'align-items': 'flex-start',
                          gap: '10px'
                      }
                    : {}
        },
        setup() {
            const { isMobile } = useCheckScreen()

            return {
                screen: {
                    isMobile
                }
            }
        },
        async created() {
            this.payout = await this.fetchPayoutArtist()
        },
        methods: {
            async fetchPayoutArtist() {
                try {
                    const response = await axios.get(
                        `${this.URLS.xhr.fetch.artistPayout[0]}/${this.eventId}/${this.URLS.xhr.fetch.artistPayout[1]}`
                    )
                    return response.data.data
                } catch (e) {
                    notification('error', e)
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    p {
        margin-bottom: 0px;
    }
    button {
        border: none;
    }

    .payout-summary-artist-container {
        padding: 20px 24px 32px 24px;
        background: #262626;
        border-radius: 15px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .title {
            color: #acacac;
            font-family: Instrument Sans;
            font-size: 26px;
            font-style: normal;
            font-weight: 500;
            line-height: 120%;
            letter-spacing: -0.52px;
        }

        .payout-wrapper {
            margin-top: 60px;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            flex-wrap: wrap;
            align-items: center;
            gap: 28px;

            .payout-info {
                color: #acacac;
                font-family: Instrument Sans;
                font-size: 44px;
                font-style: normal;
                font-weight: 500;
                line-height: 110%;
                letter-spacing: -1.76px;
            }
            .payout-paid-by,
            .clear-date {
                color: #acacac;
                font-family: Instrument Sans;
                font-size: 20px;
                font-style: normal;
                font-weight: 550;
                line-height: 120%;
                letter-spacing: -0.2px;
            }
        }
        .payout-languages {
            margin-top: 1rem;
            color: #acacac;
            font-family: Instrument Sans;
            font-size: 16px;
            font-style: normal;
            font-weight: 550;
            line-height: 120%;
            letter-spacing: -0.2px;
        }

        .hedlyner-msg {
            margin-top: 24px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: space-between;
            max-width: 576px;
            min-height: 114px;

            .payout-info,
            .payout-support {
                color: #acacac;
                font-family: Instrument Sans;
                font-size: 16px;
                font-style: normal;
                font-weight: 550;
                line-height: 125%;

                .contact-support {
                    display: block;
                    color: inherit;
                }
            }
        }
    }
</style>
